import { axiosInstance, axiosJsonInstance } from "@/axios.instance";
import { LockdownConfiguration, UpdateLockdownDetailsPayload } from "@/store/lockdown/types";
import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import { UpdateReaderGroupsPayload } from "@/store/lockdown/types";
import { GetReaderGroupsResponse } from "@/store/lockdown/types";
import { UpdateReaderGroupsCFLResponse, ReaderGroup } from "@/store/lockdown/types";
import { BadgeActivityResponse } from "@/types/ccure/BadgeActivity";
import { PostDoorActionLogPayload } from "@/store/ccure/types";

export interface CCureResponse {
	successful: boolean;
	configuration: LockdownConfiguration;
	error: string;
}

class ImmixCloudV2ApiHttpCCure {
	private axios: AxiosInstance;
	private axiosJson: AxiosInstance;

	constructor() {
		this.axios = axiosInstance;
		this.axiosJson = axiosJsonInstance;
	}

	public async testConnection(serverID: number): Promise<AxiosResponse<CCureResponse>> {
		return await this.axios.get(`/CCure/TestConnection/${serverID}`);
	}

	public async postLogMessageAll(
		predefinedMessage: string,
		freeFormMessage: string,
		eventID: number | string
	): Promise<any> {
		return this.axios.post("/CCure/Log/All", {
			PredefinedMessage: predefinedMessage,
			FreeFormMessage: freeFormMessage,
			EventID: eventID
		});
	}

	public async postLogMessage(
		eventRecordID: number | string,
		predefinedMessage: string,
		freeFormMessage: string,
		eventID: number | string
	): Promise<any> {
		return this.axios.post(`/CCure/Log/${eventRecordID}`, {
			PredefinedMessage: predefinedMessage,
			FreeFormMessage: freeFormMessage,
			EventID: eventID
		});
	}

	public async resetActions(eventRecordID: any) {
		return this.axios.get(`/CCure/ResetActions/${eventRecordID}`);
	}

	public async resetAllActions(eventID: any) {
		return this.axios.get(`/CCure/ResetAllActions/${eventID}`);
	}

	public async resetAllActionsWithRegion(eventID: any, regionID: any) {
		return this.axios.get(`/CCure/ResetAllActions/${eventID}/${regionID}`);
	}

	public async getLockdownConfiguration(groupID: number): Promise<AxiosResponse<CCureResponse>> {
		return await this.axios.get(`/CCure/GetLockdownConfiguration/${groupID}`);
	}

	public async setLockdownConfiguration(updateConfigurationPayload: UpdateLockdownDetailsPayload): Promise<AxiosResponse<CCureResponse>> {
		return await this.axiosJson.post(`/CCure/SetLockdownConfiguration`, updateConfigurationPayload);
	}

	public async getReaderGroups(
		groupId: number,
		designated: boolean,
		undesignated: boolean
	): Promise<AxiosResponse<GetReaderGroupsResponse>> {
		return await this.axiosJson.get(`/CCure/GetReaderGroups/${groupId}`, {
			params: {
				designated,
				undesignated
			}
		});
	}

	public async updateReaderGroupsClearanceLevel(
		payload: UpdateReaderGroupsPayload
	): Promise<AxiosResponse<UpdateReaderGroupsCFLResponse>> {
		return await this.axiosJson.post("/CCure/UpdateReaderGroupsClearanceLevel", payload);
	}

	public async getReaderGroupsForDoor(
		deviceId: number,
		regionUrl: string
	): Promise<AxiosResponse<GetReaderGroupsResponse>> {
		return await this.axiosJson.get(`/CCure/ReaderGroupsForDoor/${deviceId}`, { regionUrl });
	}

	public async addLogEntryForForceRestore(eventRecordId: number, restoralReason: string): Promise<void> {
		return await this.postLogMessage(eventRecordId, "Event Force Restored", restoralReason, null);
	}

	public async addLogEntryForDoorAction(payload: PostDoorActionLogPayload) {
		return await this.axiosJson.post(`/CCure/LogDoorAction`, payload);
	}

	public async getActivityBadgesByResponse(deviceId: number, input1: number, input2: number, serverTypeEventNum: number):
		Promise<AxiosResponse<BadgeActivityResponse[]>> {
		return await this.axiosJson.get(`/CCure/GetActivityBadgesByResponse/${deviceId}/${input1}/${input2}/${serverTypeEventNum}`);
	}
}

const ccureapi = new ImmixCloudV2ApiHttpCCure();
export default ccureapi;
